@for (image of images; track image; let index = $index) {
  @if (index === selectedIndex) {
    <img [src]="images[index]" @enterLeaveFadeAnimation />
  }
}
@if (images.length > 1 && (!hideDotsOnPause || (hideDotsOnPause && !isPaused))) {
  <div class="dots" @enterLeaveFadeAnimation>
    @for (image of images; track image; let index = $index) {
      <button class="dot" (click)="handleImageDotClick($event, index)" [class.selected]="index === selectedIndex"></button>
    }
  </div>
}